import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Profile() {
  const { user, refreshMe } = useAuth();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const changePassword = async (e) => {
    e.preventDefault();

    if (newPassword.length < 10) {
      toast.error("New password must be at least 10 characters");
      return;
    }

    setLoading(true);

    try {
      await api.post("/auth/change-password", {
        current_password: currentPassword,
        new_password: newPassword,
      });

      setCurrentPassword("");
      setNewPassword("");
      await refreshMe();
      toast.success("Password changed successfully");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not change password");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div data-testid="profile-page">
      <div className="mb-6">
        <h1 className="font-chivo font-black text-4xl tracking-tight">Account Settings</h1>
        <p className="text-sm text-gray-500 mt-2">{user?.email}</p>
      </div>

      <div className="border border-gray-200 bg-white p-6">
        <div className="text-xs font-mono uppercase tracking-wider text-gray-500 mb-1">Security</div>
        <h2 className="font-chivo font-black text-2xl tracking-tight mb-2">
          Change Password
        </h2>
        <p className="text-sm text-gray-500 mb-4">
          Update the password for your own user account.
        </p>

        <form onSubmit={changePassword} className="max-w-md">
          <label className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-1">
            Current password
          </label>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            className="w-full border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:border-black"
            required
          />

          <label className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-1 mt-4">
            New password
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:border-black"
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="bg-black text-white hover:bg-gray-800 px-4 py-2.5 text-sm font-semibold uppercase tracking-wider mt-6 disabled:opacity-50"
          >
            {loading ? "Updating…" : "Change Password"}
          </button>
        </form>
      </div>

    </div>
  );
}
